var _document$documentEle;
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
//Limitless import
import { withi18n } from "../../hocs/i18n";
import SubmitButton from "../../forms/submit-button/SubmitButton";
const isRTL = typeof document !== "undefined" && ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.getAttribute("dir")) === "rtl";
export const wrapTextForRTL = text => isRTL ? `\u202A${text}\u202C` : text;
const BAD = wrapTextForRTL("We're sorry to hear that. What can we do to improve?", isRTL);
const PENSIVE = wrapTextForRTL("Sounds like we could've done better. What can we do to improve?", isRTL);
const GOOD = wrapTextForRTL("Great, sounds like things went well. What stood out the most to you?", isRTL);
const DEFAULT_HEADER = wrapTextForRTL("Give a compliment or share feedback?", isRTL);
const TestimonialScreen = ({
  classes,
  t,
  testimonial = "",
  onSubmitTestimonial,
  onCancelDialog,
  containerClass,
  getButtonLabel,
  isMandatory = false,
  id,
  headingTitle,
  customerScore,
  custScoreScheme
}) => {
  const [localState, setLocalState] = React.useState({
    text: "",
    errorMessage: null,
    disableSubmit: testimonial !== "" ? false : true
  });
  const {
    text,
    errorMessage,
    disableSubmit
  } = localState;
  React.useEffect(() => {
    if (testimonial) {
      setLocalState({
        ...localState,
        text: testimonial
      });
    } else {
      setLocalState({
        ...localState
      });
    }
  }, []);
  const heading = React.useMemo(() => {
    try {
      if (headingTitle) {
        return headingTitle;
      } else {
        var _headings;
        const headings = [];
        const middle = Math.floor(Array(custScoreScheme.maxScore).length / 2);
        for (let i = 0; i < custScoreScheme.maxScore; i++) {
          if (i < middle) {
            headings.push(BAD);
          } else if (i === middle) {
            headings.push(PENSIVE);
          } else {
            headings.push(GOOD);
          }
        }
        return (_headings = headings[customerScore - 1]) !== null && _headings !== void 0 ? _headings : DEFAULT_HEADER;
      }
    } catch {
      return DEFAULT_HEADER;
    }
  }, [customerScore, custScoreScheme, headingTitle]);
  const buttonLabel = React.useMemo(() => getButtonLabel(text), [text]);
  const handleTextChange = value => {
    const text = value.trim() === "" ? value.trim() : value;
    if (text !== "" && (text.length < 5 || text.length > 500)) {
      const errorMessage = wrapTextForRTL(t("Please enter between 5 and 500 characters"), isRTL);
      setLocalState({
        ...localState,
        errorMessage,
        disableSubmit: true,
        text
      });
    } else {
      setLocalState({
        ...localState,
        errorMessage: null,
        text,
        disableSubmit: false
      });
    }
  };
  const onSubmit = () => {
    setLocalState({
      ...localState,
      disableSubmit: true
    });
    onSubmitTestimonial(text);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${containerClass} ${classes.testimonialScreen}`
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.testimonialFieldContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    component: "div"
  }, t(heading)), /*#__PURE__*/React.createElement(TextField, {
    classes: {
      root: headingTitle ? classes.textFieldWithTitle : classes.textField
    },
    FormHelperTextProps: {
      classes: {
        contained: errorMessage ? classes.helperContainer : classes.helperContainerWidth
      },
      component: "div"
    },
    InputProps: {
      classes: {
        notchedOutline: classes.notchedOutline,
        focused: classes.focused
      }
    },
    error: errorMessage ? true : false,
    id: id,
    variant: "outlined",
    value: text,
    multiline: true,
    rows: 4,
    onChange: event => handleTextChange(event.target.value)
  }), /*#__PURE__*/React.createElement(FormHelperText, {
    error: true,
    style: {
      marginBottom: 8,
      textAlign: isRTL ? "right" : "left"
    },
    id: "testimonialHelperText",
    component: "div"
  }, errorMessage || " ")), /*#__PURE__*/React.createElement("div", {
    className: classes.submitButtonContainer
  }, /*#__PURE__*/React.createElement(SubmitButton, {
    handleSubmit: onSubmit,
    disabled: text !== "" ? disableSubmit : isMandatory,
    id: `testimonial${id === "testimonialTextareaWithScoreHeading" ? `WithScore${buttonLabel}` : `${buttonLabel}`}Button`,
    containerEnabled: false,
    title: buttonLabel,
    loading: false
  })));
};
const styles = theme => ({
  testimonialScreen: {
    textAlign: "center"
  },
  textField: {
    width: 250,
    marginTop: 12
  },
  textFieldWithTitle: {
    width: 250,
    marginTop: 16
  },
  testimonialFieldContainer: {
    alignItems: "center"
  },
  submitButtonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end"
  },
  helperContainer: {
    margin: 0
  },
  helperContainerWidth: {
    display: "none"
  },
  notchedOutline: {},
  focused: {
    "&$focused $notchedOutline": {
      borderColor: theme.palette.text.secondary,
      borderWidth: 1
    }
  }
});
export default withStyles(styles)(withi18n(TestimonialScreen, "TestimonialScreen"));
TestimonialScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  testimonial: PropTypes.string,
  onSubmitTestimonial: PropTypes.func.isRequired,
  onCancelDialog: PropTypes.func.isRequired,
  containerClass: PropTypes.string.isRequired,
  buttonDisabled: PropTypes.bool,
  isMandatory: PropTypes.bool,
  getButtonLabel: PropTypes.func.isRequired,
  id: PropTypes.string,
  custScoreScheme: PropTypes.object,
  customerScore: PropTypes.number,
  headingTitle: PropTypes.string
};